export const brand = {
    talent_violet: '#A04191',
    analyzer: '#1D3557'
};

const theme = {
    colors: {
        main: brand.analyzer,
        main_light: '#F4FCFF',
        blue: '#457B9D',
        black: '#000',
        white: '#FFF',
        text: '#333',
        text_black: 'rgba(0,0,0,0.85)',
        default_text: 'rgba(0,0,0,0.65)',
        gray_dark: '#898989',
        gray_darker: '#777',
        gray_light: '#f8f8f8',
        gray_lighter: '#A4A4A4',
        gray_lightest: '#f1f1f1',
        border_light_gray: '#E5E5E5',
        green_active: '#82AD73',
        green_bright: '#52C41A',
        red_deactive: '#C16E5C',
        red_bright: '#F5222D',
        yellow_bright: '#FAAD14'
    },
    fonts: {
        light:
            '"Galano Grotesque Alt", "Open Sans", sans-serif; font-weight: 300',
        regular:
            '"Galano Grotesque Alt", "Open Sans", sans-serif; font-weight: 400',
        medium:
            '"Galano Grotesque Alt", "Open Sans", sans-serif; font-weight: 500',
        semibold:
            '"Galano Grotesque Alt", "Open Sans", sans-serif; font-weight: 600',
        bold:
            '"Galano Grotesque Alt", "Open Sans", sans-serif; font-weight: 700',
        openSans: '"Open Sans", sans-serif; font-weight: 400',
        openSans_bold: '"Open Sans", sans-serif; font-weight: 600'
    },
    typography: {
        base_font_size: '14px',
        base_line_height: 1.4,
        description: '14px'
    },
    shadows: {},
    componentMeasures: {
        leftNavWidth: '280px',
        searchBarHeight: '54px',
        topNavHeight: '65px',
        sectionPaddingTotal: '40px'
    }
};

export default theme;
